import { createGlobalStyle } from 'styled-components'
import './styles/font.css'

export const GlobalStyle = createGlobalStyle`
    *,
    *::before,
    *::after{
        box-sizing: border-box;
    }
    html{
        font-size: 75%;
    @media(max-width: 400px){
            font-size: 62.5%;
    }
    @media(min-width: 900px){
            font-size: 87.5%;
    }
    }
    body{
        margin: 0; 
        font-family: 'Nunito Sans', sans-serif;
        font-weight: 300;
        min-height: 100vh;
        background-color:  ${({ theme }) => theme.colors.primaryColor};
        color:  ${({ theme }) => theme.colors.textPrimary};
        transition: ${({ theme }) => theme.transition.default};
        overflow-x: hidden;
    }
    a,
    button{
        font-family: inherit;
        cursor: pointer;
    }
   @keyframes elipseAnimation {
       0%{
           opacity: 0;
           transform: scale(.8);
       }
       50%{
           opacity: 1;
          transform: scale(1);

       }
       100%{
           opacity:1; 
           transform: scale(.8);      
       }
   }
`;
